import React, { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getAllActiveCompanys } from "../../../api/action/company";
import { academyLogger } from "utils/logger";

export default function Partners() {
  const [companies, setCompanies] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isScrolling, setIsScrolling] = useState(true); // New state to manage auto-scrolling
  const dispatch = useDispatch();

  const fetchActiveCompanies = useCallback(async () => {
    try {
      const activeCompanies = await dispatch(getAllActiveCompanys());
      setCompanies(activeCompanies); // Set the fetched companies data
    } catch (error) {
      academyLogger.error("Error fetching companies:", error);
    } finally {
      setIsLoading(false);
    }
  }, [dispatch]);

  useEffect(() => {
    fetchActiveCompanies();
  }, [fetchActiveCompanies]);

  useEffect(() => {
    const scrollInterval = setInterval(() => {
      if (isScrolling) {
        const scrollContainer = document.querySelector('.overflow-x-scroll');
        if (scrollContainer) {
          scrollContainer.scrollBy({ left: 2, behavior: 'smooth' }); // Slightly faster scroll
        }
      }
    }, 30); // Adjust speed of auto-scroll

    // Clear interval on component unmount
    return () => clearInterval(scrollInterval);
  }, [isScrolling]);

  const handleMouseDown = () => {
    setIsScrolling(false); // Stop auto-scrolling when the user touches the container
  };

  const handleMouseUp = () => {
    setIsScrolling(true); // Resume auto-scrolling when the user stops touching the container
  };

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="bg-white py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <h2 className="text-center text-lg font-semibold text-[rgb(8,64,88)]">
          Trusted by the world’s most innovative teams
        </h2>
        <div className="relative mt-10">
          <div
            className="flex overflow-x-scroll scroll-smooth gap-x-8 py-2"
            onMouseDown={handleMouseDown}
            onMouseUp={handleMouseUp}
            onTouchStart={handleMouseDown} // Also stop scrolling on touch start
            onTouchEnd={handleMouseUp} // Resume scrolling on touch end
          >
            {companies.map((company, index) => (
              <div
                key={index}
                className="flex-shrink-0 transition-all duration-500 transform hover:scale-110"
              >
                <img
                  alt={company.name}
                  src={company.logoLocation} // Ensure this is the correct logo field
                  width={180}  // Increased size
                  height={54}  // Increased size
                  className="max-h-16 object-contain"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
